import { useMemo } from 'react';

import { useAppState } from '../../AppStateProvider';
import type { LockVariant } from '../../domain/gainAccessView';
import { useCompanyQuotaQuery } from '../../features/company/useCompanyQuotaQuery';
import { useUserStatus } from '../../hooks/useUserStatus';

const useCompanyQuotaCheck = () => {
  const { isCompanyQuotaReached } = useAppState();
  const { isNoTouch } = useUserStatus();
  const companyQuota = useCompanyQuotaQuery().data;

  const isQuotaReached = useMemo(
    () => companyQuota && companyQuota?.remaining <= 0 && isCompanyQuotaReached,
    [companyQuota, isCompanyQuotaReached]
  );

  const variant: LockVariant = isNoTouch
    ? 'company-monthly-limit-reached-nt'
    : companyQuota?.interval === 'monthly'
      ? 'company-monthly-limit-reached'
      : 'company-daily-limit-reached';

  return { variant, isQuotaReached };
};

export default useCompanyQuotaCheck;
